module.exports = __webpack_public_path__ + "img/ltkseasonal-1x.4c99ddd.jpg";